<template>
  <div class="">
    <form @submit.prevent="submit">
      <div class="form-group">
        <label>دامنه</label>
        <select required v-model="form.domain" class="custom-select">
          <option value="domain">دامنه اصلی</option>
          <option value="api_url">Api</option>
          <option value="dashboard_url">داشبورد</option>
        </select>
      </div>

      <div class="form-group">
        <label for="domain-manager-value">مقدار</label>
        <input required v-model="form.value" type="text" class="form-control" id="domain-manager-value">
      </div>

      <div class="form-group">
        <label>نوع</label>
        <select required v-model="form.dns_type" class="custom-select">
          <option value="TXT">TXT</option>
          <option value="A">A</option>
          <option value="AAAA">AAAA</option>
          <option value="CNAME">CNAME</option>
          <option value="MX">MX</option>
          <option value="NS">NS</option>
          <option value="PTR">PTR</option>
          <option value="SRV">SRV</option>
          <option value="CAA">CAA</option>
          <option value="SOA">SOA</option>
        </select>
      </div>

      <div class="col-12 text-center">
        <button type="submit" class="btn btn-primary rounded-pill px-5">ثبت</button>
      </div>


    </form>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "DomainManagerForm",
  props: {
    item: {}
  },
  data() {
    return {
      form: {
        dns_type: null,
        value: null,
        domain: null,
      }
    }
  },
  computed: {
    ...mapGetters({
      project: "ProjectAlpha/getProject",
    }),
    isUpdateMode() {
      return this.item != null
    }
  },
  methods: {
    createDns() {
      let form = {
        project_id: this.project.id,
        ...this.form
      }
      this.$store.dispatch('DnsManager/createDnsRecord', form).then((res) => {
        toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.')
        this.$store.dispatch('ProjectAlpha/getProject', form)
      })
    },
    updateDns() {
      let form = {
        project_id: this.project.id,
        item_id: this.item.id,
        ...this.form
      }
      this.$store.dispatch('DnsManager/updateDnsRecord', form).then((res) => {
        toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.')
        this.$store.dispatch('ProjectAlpha/getProject', form)
      })
    },
    submit() {
      if (this.isUpdateMode) {
        this.updateDns()
      } else {
        this.createDns()
      }
    },
    findDnsRecordDomainType(item) {
      let project = this.project

      let domainTypes = ['api_url', 'dashboard_url', 'domain']
      let result = 'domain'
      let domain = item['domain'].slice(3)

      domainTypes.forEach(domainType => {
        let projectDomain = project[domainType].replace('https://', '').replace('/api', '').replace('/', '')
        if (domain === projectDomain) {
          result = domainType
        }
      })
      return result
    },
    formSetter() {
      let itemValue = Object.assign({}, this.item.value)
      itemValue.domain = this.findDnsRecordDomainType(itemValue)
      return itemValue
    }
  },
  mounted() {
    if (this.item != null) {
      this.form = this.formSetter()
    }
  }
}
</script>

<style scoped>

</style>